<template>
  <div v-if="vShow">
    <div
      :class="{ show: aShow }"
      class="modal-backdrop fade modal-stack"
      style="z-index: 1039"
      @click="hide"
    ></div>
    <div
      id="addToCart"
      :class="{ show: aShow }"
      aria-modal="true"
      class="modal fade"
      style="z-index: 1040; display: block"
    >
      <div
        id="modal-size"
        class="modal-dialog modal-dialog-centered"
        role="document"
      >
        <div class="modal-content position-relative">
          <div class="c-preloader text-center p-3" style="display: none">
            <i class="las la-spinner la-spin la-3x"></i>
          </div>
          <button
            aria-label="Close"
            class="close absolute-top-right btn-icon close z-1"
            data-dismiss="modal"
            type="button"
            @click="hide"
          >
            <span aria-hidden="true" class="la-2x">×</span>
          </button>
          <div id="addToCart-modal-body">
            <div class="modal-body p-4 added-to-cart" style="max-height: 90vh">
              <div class="text-center text-success mb-4">
                <i class="las la-check-circle la-3x"></i>
                <h3>{{ $t("项目添加到您的购物车") }}！</h3>
              </div>
              <div class="media mb-4">
                <img
                  :src="getFileViewUrl(spec.pic || spec.goodsPic)"
                  alt="Product Image"
                  class="mr-3 size-100px img-fit rounded ls-is-cached lazyloaded"
                />
                <div class="media-body pt-3 text-left">
                  <div v-if="spec.goodsName">{{ $t(spec.goodsName) }}</div>
                  <h6 class="fw-600">
                    {{ $t(spec.name) }}
                  </h6>
                  <div class="row mt-3">
                    <div class="col-sm-2 opacity-60">
                      <div>{{ $t("价格") }}:</div>
                    </div>
                    <div class="col-sm-10">
                      <div class="h6 text-primary">
                        <strong> {{ formatMoney(priceDiscount(spec.price)) }} </strong>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="bg-white rounded shadow-sm">
                <div class="border-bottom p-3">
                  <h3 class="fs-16 fw-600 mb-0">
                    <span class="mr-4">{{ $t("经常一起购买") }}</span>
                  </h3>
                </div>
                <div class="p-3">
                  <ProductsSlide :list="goodsListCateCode" />
                </div>
              </div>
              <div class="text-center">
                <button
                  class="btn btn-outline-primary mb-3 mb-sm-0 mr-3"
                  data-dismiss="modal"
                  @click="hide"
                >
                  {{ $t("返回购物") }}
                </button>
                <router-link
                  class="btn btn-primary mb-3 mb-sm-0"
                  to="/user/cart"
                  >{{ $t("进行结算") }}
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ProductsSlide from "@/components/ProductsSlide.vue";

export default {
  data() {
    return {
      vShow: false,
      aShow: false,
      goodsListCateCode: [],
      goods: {},
      spec: {},
      cateCode: 0
    };
  },
  computed: {
    info() {
      return this.$store.state.common.itemAddedToCartDialogInfo;
    }
  },
  watch: {
    info(info) {
      if (info) {
        this.show();
      } else {
        this.hide();
      }
    },
    $route() {
      this.hide();
    }
  },
  components: { ProductsSlide },
  methods: {
    priceDiscount(price) {
      let buyDiscount = this.goods.buyDiscount || 100;
      return price * buyDiscount / 100
    },
    show() {
      console.log("info", this.info);
      this.goods = this.info.goods;
      this.spec = this.info.spec;
      this.cateCode = this.info.cateCode;
      this.vShow = true;
      // 在界面初始化的时候就是这个样式的话，就不会做过渡动画 所以间隔一帧再修改样式
      requestAnimationFrame(() => (this.aShow = true));
      this.pageGoodsCateCode();
    },
    hide() {
      this.aShow = false;
      setTimeout(() => {
        this.vShow = false;
      }, 150);
    },
    async pageGoodsCateCode() {
      const params = { goodsCateCode: this.cateCode };
      const page = (await this.$get("/goods/page", { params })).data;
      this.goodsListCateCode = page.records;
    }
  }
};
</script>
